import { ImageIcon } from "lucide-react";

// Ramka na zdjęcie Anny. Gdy src === null, pokazuje estetyczny placeholder
// gotowy do podmiany przez wpis w src/config/landingConfig.js (IMAGES).
export const PhotoSlot = ({ src, alt, slotLabel, className = "", imgClassName = "" }) => {
  if (src) {
    return (
      <div className={`overflow-hidden ${className}`}>
        <img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover ${imgClassName}`} />
      </div>
    );
  }
  return (
    <div
      data-testid={`photo-slot-${slotLabel}`}
      role="img"
      aria-label={alt}
      className={`flex flex-col items-center justify-center gap-3 bg-cyan-soft text-center ${className}`}
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl border-2 border-dashed border-ink/40 bg-white">
        <ImageIcon className="h-6 w-6 text-ink/50" aria-hidden="true" />
      </span>
      <p className="max-w-[180px] text-xs font-bold uppercase tracking-[0.14em] text-ink/50">
        Zdjęcie Anny - {slotLabel}
      </p>
    </div>
  );
};
